import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class PortalsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            {
                label: 'Resource',
                key: 'resource',
                type: 'textfield',
            },
        ];
    }
}
